import { fromJS } from 'immutable'
import * as contentDirectory from './contentDirectoryActions'

const initialState = fromJS({
	isLoading: false,
	isPublishing: false,
	contentAssets: [],
	total: 0,
	pageNumber: 1,
	pageSize: contentDirectory.DEFAULT_PAGE_SIZE,
	query: '',
	error: null,
	// slice 5 — filter state mirrored from the URL.
	selectedCategoryId: null,
	selectedTagIds: [],
	categoryCounts: [],
	allCount: 0,
	gridMode: false
})

const contentDirectoryReducer = (state = initialState, action) => {
	switch (action.type) {
		case contentDirectory.IS_LOADING_CONTENT_ASSETS: {
			return state.set('isLoading', action.status)
		}
		case contentDirectory.SET_CONTENT_ASSETS: {
			const { contentAssets, total, pageNumber, pageSize, query, categoryCounts, allCount } = action.payload
			return state
				.set('contentAssets', fromJS(contentAssets))
				.set('total', total)
				.set('pageNumber', pageNumber)
				.set('pageSize', pageSize)
				.set('query', query)
				.set('categoryCounts', fromJS(categoryCounts || []))
				.set('allCount', typeof allCount === 'number' ? allCount : 0)
				.set('error', null)
		}
		case contentDirectory.SET_CONTENT_ASSETS_ERROR: {
			return state.set('error', fromJS({ message: action.error && action.error.message ? action.error.message : 'Request failed' }))
		}
		case contentDirectory.IS_PUBLISHING_ASSET: {
			return state.set('isPublishing', action.status)
		}
		case contentDirectory.SET_DIRECTORY_FILTER_STATE: {
			// Idempotent sync from URL parse → store. Whatever the caller sends,
			// the reducer takes verbatim; null/empty mean "no filter".
			const { selectedCategoryId, selectedTagIds, gridMode } = action.payload || {}
			return state
				.set('selectedCategoryId', selectedCategoryId == null ? null : selectedCategoryId)
				.set('selectedTagIds', fromJS(Array.isArray(selectedTagIds) ? selectedTagIds : []))
				.set('gridMode', Boolean(gridMode))
		}
		default:
			return state
	}
}

export default contentDirectoryReducer
